import { render, staticRenderFns } from "./leidathree.vue?vue&type=template&id=c57918d4&"
import script from "./leidathree.vue?vue&type=script&lang=js&"
export * from "./leidathree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports